import Layout from "Layout"
import DailyChecklist from "./DailyChecklist"

const BehavioralPerformance = () => {
  return(
    <Layout>
      <DailyChecklist />
    </Layout>
  )
}

export default BehavioralPerformance